export const getApiUrl = () => {
  let apiUrl = "";

  if (process.env.REACT_APP_API_URL) {
    apiUrl = process.env.REACT_APP_API_URL + "/v1";
  }
  return apiUrl;
};
